package io.horion.cv.models

data class Testimonial(
    val imgSrc: String,
    val comment: String,
    val name: String,
    val job: String,
    val star: Int
)
